import { Print } from '@mui/icons-material';
import {
  Box,
  Button,
  Typography
} from '@mui/material';
import { FolderQrCode } from 'modules/components/layer05';



export type QrCodeDetailSectionProps = {
  entityType?: string;
  entityId?: string;
  projectId?: string;
};

export const FC = ({
  entityType, entityId, projectId
}: QrCodeDetailSectionProps) => {
  if (!entityId || !projectId) {
    return (
      <Box>
        <Typography>
          Malformed URL. Cannot generate QR Code.
        </Typography>

        <Typography>
          Entity type: {entityType}. {entityId}
        </Typography>
      </Box>
    );
  }

  if (entityType !== 'folder') {
    return <div>Unsupported entity type {entityType}</div>;
  }

  return (
    <Box sx={{
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}
    >
      <Button
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          '@media print': {
            display: 'none'
          }
        }}
        startIcon={<Print />}
        onClick={() => {
          window.print();
        }}
      >
        Print
      </Button>

      {entityType === 'folder' && (
        <FolderQrCode.FC
          folderId={entityId}
          projectId={projectId}
        />
      )}
    </Box>
  );
};
